<template>
  <div class="sf-multi-tab">
    <a-button class="left-btn" icon="left" @click="goLeft" :disabled="leftShow"
      v-show="tabsWidth>centerWidth" />
    <div class="center" ref="center">
      <div class="tabs " ref="tabs" :style="{transform:'translateX('+tabX+'px)'}">
        <a-tag v-for="(tab,index) in tabs" :key="tab.path"
          :class="['tab', {active:activeTab === tab.path}]" :closable="index>0"
          @click.stop="clickTab(tab.path)" @close.stop="closeTab(tab.path)">
          <span style="color:#000;">{{tab.name}}</span>
        </a-tag>
      </div>
    </div>
    <a-button class="right-btn" icon="right" @click="goRight" :disabled="rightShow"
      v-show="tabsWidth>centerWidth" />
    <div class="closeAll" @click="closeAllTabs" v-if="tabs.length>1">
      <a-icon type="close" />
    </div>

  </div>
</template>

<script>
import events from "./events";
import { mapGetters } from "vuex";
import Vue from "vue";

export default {
  name: "MultiTab",

  data() {
    return {
      tabX: 0,
      centerWidth: 0,
      tabsWidth: 0,
      lastTabx: 0,
      rightShow: false,
      leftShow: true,
      timer: null,
      targetpath: "",
    };
  },

  created() {
    const tabs = Vue.ss.get("tabs");
    if (tabs !== null) {
      this.$store.dispatch("InitTabs", tabs);
      setTimeout(() => {
        this.recalcuWidth(true);
      }, 0);
    }

    // 绑定事件
    events.$on("open", (path, name) => {
      this.$store
        .dispatch("OpenTab", {
          path: path,
          name: name,
        })
        .then((type) => {
          if (type) {
            const tabs = Vue.ss.get("tabs");
            this.tabsWidth = 0;
            let leftValue =
              this.$refs.tabs.getElementsByClassName("ant-tag active")[0]
                .offsetLeft; //距离左边的距离，当前
            let curValue =
              this.$refs.tabs.getElementsByClassName("ant-tag active")[0]
                .clientWidth; //当前值
            this.tabsWidth = leftValue + curValue + tabs.length * 2;
            if (this.tabsWidth > this.centerWidth) {
              this.tabX = this.centerWidth - this.tabsWidth;
              this.rightShow = true;
              console.log("新增" + this.rightShow);
            }
          } else {
            let a =
              this.$refs.tabs.getElementsByClassName("active")[0].offsetLeft; //距离左边的距离，当前
            if (a > this.centerWidth) {
              this.tabX =
                this.centerWidth -
                a -
                this.$refs.tabs.getElementsByClassName("active")[0].offsetWidth;
            } else {
              this.tabX = 0;
            }

            // offsetLeft
          }
          if (this.tabX < 0) {
            //如果小于0 左移显示
            this.leftShow = false;
            // this.rightShow = false
            if (this.tabsWidth - this.centerWidth - this.tabX <= 10) {
              this.rightShow = true;
            }
          } else {
            this.rightShow = false;
            this.leftShow = true;
          }
        });
    });

    events.$on("close", (path) => {
      this.closeTab(path);
    });

    this.$store.dispatch("OpenTab", {
      path: this.$route.fullPath,
      name: this.$route.meta.title,
    });
  },
  mounted() {
    this.recalcuWidth();
  },
  computed: {
    ...mapGetters(["tabs", "activeTab", "pathBox"]),
  },
  updated() {
    this.centerWidth = this.$refs.center.clientWidth;
    //this.tabsWidth = this.$refs.tabs.clientWidth  //IE取值不对
  },

  methods: {
    closeAllTabs() {
      let that = this;
      this.$confirm({
        title: "确定关闭全部标签么?",
        okText: "确定",
        cancelText: "取消",
        onOk() {
          that._closeAll();
        },
      });
    },
    _closeAll() {
      this.$store.dispatch("SetCurrentMenuCode", "").then(() => {
        this.$store.dispatch("closeAllTab");
        setTimeout(() => {
          this.recalcuWidth(true);
        }, 0);
      });
    },

    closeTab(path) {
      this.$store.dispatch("SetCurrentMenuCode", "").then(() => {
        this.$emit("afterClose", path);
        // let index = this.pathBox.indexOf(String(path))
        // let array = this.$refs.tabs.getElementsByClassName('ant-tag')
        events.$emit("clear", path, () => {
          this.$store.dispatch("CloseTab", path);
        });
        this.recalcuWidth(false, path);
      });

      // console.log(this.pathBox);
      //   // 如果tabx大于0那就减 小于0就加
      //   this.tabsWidth = this.tabsWidth - array[index].clientWidth
      //   if(this.tabsWidth <= this.centerWidth) {
      //     this.$refs.tabs.style.transform = 'translateX(0px)'
      //   } else {
      //     this.tabX = this.centerWidth - this.tabsWidth
      //     this.rightShow = true
      //   }

      // this.$refs.tabs.style.transform = 'translateX('+ this.tabx - array[index].clientWidth +'px)'

      // if(this.tabsWidth < this.centerWidth) {
      //   console.log(111);
      //   this.$refs.tabs.style.transform = 'translateX(0px)'

      // }
    },
    recalcuWidth(param = false, path) {
      // 如果tabx大于0那就减 小于0就加
      console.log(this.pathBox);
      let array = this.$refs.tabs.getElementsByClassName("ant-tag");
      // 如果tabx大于0那就减 小于0就加
      this.tabsWidth = this.tabsWidth - array[0].clientWidth;
      if (param) {
        let leftValue =
          this.$refs.tabs.getElementsByClassName("ant-tag active")[0]
            .offsetLeft; //距离左边的距离，当前
        let curValue =
          this.$refs.tabs.getElementsByClassName("ant-tag active")[0]
            .clientWidth; //当前值
        this.tabsWidth = leftValue + curValue;
        this.tabX = 0;
        return;
      } else {
        if (this.tabsWidth <= this.centerWidth) {
          this.$refs.tabs.style.transform = "translateX(0px)";
        } else {
          this.tabX = this.centerWidth - this.tabsWidth;
          this.rightShow = true;
        }
      }
    },
    clickTab(path) {
      let self = this;
      self.targetpath = path;
      clearTimeout(this.timer);
      //add by lvbl ，在这里加防抖，频繁点击，只响应一次。 todo 防抖优化
      this.timer = setTimeout(function () {
        self.$store.dispatch("ActiveTab", self.targetpath);
      }, 450);
    },
    goRight() {
      this.leftShow = false;
      let width = this.tabsWidth - this.centerWidth; //总共大于的距离
      console.log(width);
      console.log(this.tabX);
      console.log(this.tabX + width);
      if (this.tabX + width >= 30 && this.tabX + width <= 60) {
        this.tabX -= this.tabX + width;
        this.rightShow = true;
      } else if (this.tabX + width >= 0 && this.tabX + width < 30) {
        this.tabX -= this.tabX + width;
        this.rightShow = true;
      } else {
        this.tabX -= 30;
      }

      // 此处可能要根据子元素超出父元素多少，减去已平移的宽度，计算出最后一次平移的距离
    },

    goLeft() {
      this.rightShow = false;
      let width = this.tabsWidth - this.centerWidth; //总共大于的距离

      if (this.tabX + 30 > 0 || this.tabX + 30 > -10) {
        this.$refs.tabs.style.transform = "translateX(0px)";
        this.leftShow = true;
      } else {
        this.tabX += 30;
      }
    },
  },

  watch: {
    activeTab(v) {
      if (this.$route.fullPath !== v) this.$router.push(v).catch((err) => {});
    },
  },
};
</script>
<style lang="less">
.sf-multi-tab {
  display: flex;
  height: 28px;
  width: calc(100% - 30px);

  .center {
    flex: auto;
    overflow: hidden;
  }

  .tabs {
    display: flex;
    width: fit-content;
    transition: transform 0.3s;
  }

  .tab {
    padding: 7px 14px;
    line-height: 10px;
    height: 100%;
    border: 1px solid #64c2bc;
    border-bottom: 0;
    background-color: white;
    border-radius: 4px 4px 0 0;
    min-width: 90px;
    margin-right: 5px;
  }

  .left-btn {
    padding: 0px 4px !important;
    cursor: pointer;
    margin-right: 8px;
    height: 26px;
    background-color: white;
    color: #64c2bc;
    line-height: 26px;
    border: 0;
  }

  .right-btn {
    cursor: pointer;
    padding: 0px 4px !important;
    margin-left: 8px;
    height: 26px;
    background-color: white;
    /*color: #64C2BC;*/
    line-height: 26px;
    border: 0;
  }
  .closeAll {
    position: absolute;
    background-color: #fff;
    text-align: center;
    display: inline-block;
    width: 26px;
    height: 26px;
    line-height: 26px;
    right: 0px;
    color: #64c2bc;
  }
}
</style>


<style lang="less" scoped>
/deep/.active {
  color: #000;
  background: #ddf1f0;
  border-bottom: 1px solid #fff;
  padding-bottom: 10px;
  font-weight: bold;
  /*margin-top:2px;*/
}
</style>